import React, { useState, useEffect, Fragment } from 'react';
import {
    Row,
    Input,
    FormGroup,
    CustomInput,
    Button,
    ButtonGroup,
    Form,
    Modal,
    ModalBody,
    Label,
    ModalHeader
} from 'reactstrap';
import {
    Colxx,
    Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import {
    gAPI_Property_List,
    API_CustomStripe_Connection,
    dAPI_Delete_Ingetration,
    gAPI_Rooms
} from '../../../../../constants/APIs';
import CustomSelectInput from '../../../../../components/common/CustomSelectInput';
import Select from 'react-select';


let arr = [];
export default function CustomStripeIntegration({ visible, toggle, id, integration,refreshConnection,LoadIntegrations }) {
    const [selectedpropertyfordelete, setselectedpropertyfordelete] =
    useState('');
    const [deleteVisible, setDeleteVisible] = useState(false);
    const [property, setProperty] = useState([]);
    const [maskData, setMaskData] = useState({
        apiKey: "",
        publishKey: "",
    });
    const [inputData, setInputData] = useState({
        GroupId: getGroupID(),
        Name: '',
        Properties: [],
        SessionTimeoutInSeconds: 600,
        DefaultLanguage: 'en-US',
        apiKey: '',
        publishKey:'', 
    });
    const handleDelete = async (id, customerid) => {
        await AxiosAPI({
          method: 'delete',
          url: `${dAPI_Delete_Ingetration}/${id}/?group_id=${getGroupID()}`,
        }).then((res) => {
          toggle();
          refreshConnection('Archieve', customerid);
          LoadIntegrations();
        });
      };
    const checkConnct = async () => {
        integration.map((m) => {
          if (m.properties[0] === selectedpropertyfordelete) {
            handleDelete(m.id);
            toggleDelete();
          }
        });
        //console.log(integration, selectedpropertyfordelete);
      };
    useEffect(() => {        
        if (id !== undefined) {
            AxiosAPI({
                method: 'get',
                url: `${API_CustomStripe_Connection}/${id}?group_id=${getGroupID()}`,
            })
                .then(res => {                    
                    setInputData({
                        ...inputData,
                        Name: res.data.name,
                        Properties: res.data.properties !== null ? [res.data.properties[0]] : [],
                        apiKey: (res.data.customStripeIntegration.apiKey),   
                        publishKey: mask(res.data.customStripeIntegration.publishKey),                   
                    });                    
                    setMaskData({
                        ...maskData,
                        apiKey: mask(res.data.customStripeIntegration.apiKey),                        
                        publishKey: mask(res.data.customStripeIntegration.publishKey),     
                    });
                })
                .catch(err => console.log('err', err));

            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
            })
                .then(res => {
                    setProperty([...res.data]);
                })
                .catch(err => console.error(err));
        }
        else {
            AxiosAPI({
                method: 'get',
                url: `${gAPI_Property_List}/?group_id=${getGroupID()}`,
            })
                .then(res => {
                    setProperty([...res.data]);
                })
                .catch(err => console.error(err));
        }
    }, [id]);
    const mask = (value) => {
        let maskedValue = "";
        for (let i = 0; i < value.length - 2; i++) {
            maskedValue += "*";
        }
        return maskedValue + value.substring(value.length - 2, value.length);
    }

    const handleNameChange = e => {
        e.persist();
        setInputData({ ...inputData, Name: e.target.value });
    };
    const toggleDelete = () => {
        setDeleteVisible(!deleteVisible);
      };
    const generateDeleteButton = () => {
        return (
          <Row>
            <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
              <Row>
                <Colxx xs="12" sm="5" className="mb-1">
                  <Modal isOpen={deleteVisible} toggle={toggleDelete}>
                    <ModalHeader toggle={toggleDelete}>
                      <span role="img" aria-label="warning">
                        ⚠️
                      </span>
                      You have already stripe connection so for new connection
                      please disconnected all previous connection for this property
                    </ModalHeader>
                    <ModalBody>
                      <Button
                        color="danger"
                        onClick={() => checkConnct()}
                        size="xs"
                      >
                        Delete
                      </Button>
                      <Button
                        className="ml-2"
                        color="dark"
                        outline
                        size="xs"
                        onClick={toggleDelete}
                      >
                        Cancel
                      </Button>
                    </ModalBody>
                  </Modal>
                </Colxx>
              </Row>
            </Colxx>
          </Row>
        );
      };
    const handleApiKeyChange = e => {
        e.persist();
        setMaskData({ ...maskData, apiKey: mask(e.target.value) });
        setInputData({ ...inputData, apiKey: e.target.value });        
    };
    const handlePublishKeyChange = e => {
        e.persist();
        setMaskData({ ...maskData, publishKey: mask(e.target.value) });
        setInputData({ ...inputData, publishKey: e.target.value });        
    };
    const handleCheckChange = (e) => {
        let val = 0;
        integration.map((m) => {
          //console.log(m.properties[0], e);
          if (m.properties[0] === e.target.value) {
            val = 1;
            toggleDelete();
          }
        });        
        if (val === 0) {
            if (e.target.checked) {
                setInputData({ ...inputData, Properties: [e.target.value] });
            }
            if (!e.target.checked) {
                setInputData({ ...inputData, Properties: [] });
            }
        } else {
            setselectedpropertyfordelete(e.target.value);
        }
          setselectedpropertyfordelete(e.target.value);        
      };

    const handleSave = async () => {
        if (id !== undefined) {
            AxiosAPI({
                method: 'put',
                url: `${API_CustomStripe_Connection}/${id}?group_id=${getGroupID()}`,
                data: inputData,
            }).then(() => {
                setTimeout(() => {
                    LoadIntegrations();
                }, 300);
            });
            toggle();
        } else if(inputData.apiKey !== '' && inputData.publishKey !== '') {
            AxiosAPI({
                method: 'post',
                url: API_CustomStripe_Connection,
                data: inputData,
            }).then((res) => {
                setTimeout(() => {
                    LoadIntegrations();
                }, 300);
            });            
        }
        toggle();
    };
    return (
        <Fragment>
            <Modal isOpen={visible} toggle={toggle} style={{maxWidth:'50%'}}>
                <ModalBody>
                    <Row className="mb-4">
                        <Colxx xxs="12">
                            <div className="text-center">
                                <h6>Add Intregation</h6>
                                <Separator className="mb-3" />
                                <Form>
                                    <FormGroup>
                                        <Label>Intregation Name</Label>
                                        <Input
                                            type="text"
                                            name="IntregationName"
                                            onChange={handleNameChange}
                                            placeholder="Intregation Name"
                                            defaultValue={inputData.Name}
                                        />
                                    </FormGroup>
                                    <FormGroup>
                                        <Label>API key</Label>
                                        <Input
                                            type="text"
                                            name="apiKey"
                                            onChange={handleApiKeyChange}
                                            placeholder="API key"
                                            defaultValue={maskData.apiKey}
                                        />
                                    </FormGroup> 
                                    <FormGroup>
                                        <Label>Publishable key</Label>
                                        <Input
                                            type="text"
                                            name="publishKey"
                                            onChange={handlePublishKeyChange}
                                            placeholder="Publish key"
                                            defaultValue={maskData.publishKey}
                                        />
                                    </FormGroup>                                    
                                    <FormGroup className="mt-3">
                                         <div className='integration-property text-start'>                    
                                           <div className='row' style={{textAlign:'left'}}>
                                                {property.map((p, index) => {
                                                    return (
                                                        <div className='col-md-6'>
                                                            <CustomInput
                                                                key={p.id}
                                                                type="radio"
                                                                id={index}
                                                                label={p.name}
                                                                value={p.id}
                                                                name="property"
                                                                checked={p.id === inputData.Properties[0] ? true : false}
                                                                onChange={handleCheckChange}
                                                            />
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        </div>
                                    </FormGroup>
                                </Form>
                                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                                    {id === undefined ? (<Button color="primary" size="xs" onClick={handleSave}>
                                        Create New Intregation
                                    </Button>) : (<Button color="primary" size="xs" onClick={handleSave}>
                                        Update Intregation
                                    </Button>)}
                                    <Button size="xs" color="dark" outline onClick={toggle}>
                                        Cancel
                                    </Button>
                                </ButtonGroup>
                            </div>
                        </Colxx>
                    </Row>
                </ModalBody>
            </Modal>
            {generateDeleteButton()}
        </Fragment>
    );
}